import {
  type CampaignBiddingUpdate,
  type CampaignSettingsUpdate,
  campaignBiddingUpdateSchema,
  campaignSettingsUpdateSchema,
} from "@adpilot/shared";
import { z } from "zod";
import { api } from "./api";

const responseSchema = z.object({ success: z.literal(true), data: z.unknown() });

export async function updateCampaignSettings(
  id: string,
  input: CampaignSettingsUpdate,
): Promise<void> {
  const response = await api
    .patch(`campaigns/${id}/settings`, {
      json: campaignSettingsUpdateSchema.parse(input),
      retry: 0,
      timeout: 30_000,
    })
    .json<unknown>();
  responseSchema.parse(response);
}

/** 竞价调整: strategy and/or placement adjustments, written to Amazon before returning. */
export async function updateCampaignBidding(
  id: string,
  input: CampaignBiddingUpdate,
): Promise<{ changed: boolean }> {
  const response = await api
    .patch(`campaigns/${id}/bidding`, {
      json: campaignBiddingUpdateSchema.parse(input),
      retry: 0,
      // A read and a write to Amazon: wait out the server's own budget so a
      // slow success is not reported as a network failure.
      timeout: 60_000,
    })
    .json<unknown>();
  const parsed = z
    .object({ success: z.literal(true), data: z.object({ changed: z.boolean() }) })
    .parse(response);
  return parsed.data;
}
